export default "__VITE_ASSET__BQk_Ov3U__"